import KatalLogger, { Level } from '@amzn/katal-logger';

const FLEXIBLE_REPORT_BUILDER_APPLICATION_NAME = 'FLEXIBLE_REPORT_BUILDER';

// The Katal Logging URL is set through MONS route which indirectly calls our API Gateway for Katal Logging
// https://monster.mons.amazon.dev/applications/UnifiedReportCenterUI
const katalLoggerConfig = {
  url: '/caracal-katal-logger',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false
};

const appContext = window.AppContext;
const katalContext = {
  marketplaceId: appContext?.marketplaceId,
  customerId: appContext?.customerId,
  isSpoofer: appContext?.isSpoofer,
  locale: appContext?.locale,
  applicationName: FLEXIBLE_REPORT_BUILDER_APPLICATION_NAME
};

export const katalLogger = new KatalLogger(katalLoggerConfig);
katalLogger.context = katalContext;
katalLogger.addErrorListener();
